export const IFRAME_REPORTING_URL = `${window?.__RUNTIME_CONFIG__?.IFRAME_REPORTING_ORIGIN_DOMAIN}/e-services-reporting/`;
export const IFRAME_ACCESS_TOKEN = 'ACCESS_TOKEN';
export const TOKEN_EXPIRATION_GAP_SECONDS = 120;
